import type { RecapListEntry } from '@/api/generated/schemas.ts';

// The recap's sections a link can point to, as the URL's hash (useScrollToSection).
export type RecapSection = 'topics' | 'decisions' | 'todos' | 'events';

// A recap's URL is `/recaps/<public_id>-<slug>`, or just the public id while there's no title. Only the public id
// finds it, so a link without the slug, or with one from an older title, still works.
export const recapPath = (recap: Pick<RecapListEntry, 'public_id' | 'slug'>, section?: RecapSection) =>
    (recap.slug ? `/recaps/${recap.public_id}-${recap.slug}` : `/recaps/${recap.public_id}`) +
    (section ? `#${section}` : '');

// Where members preview its draft and edit it; its own URL shows the published version (plan/DECISIONS.md D107).
export const recapDraftPath = (recap: Pick<RecapListEntry, 'public_id' | 'slug'>) => `${recapPath(recap)}/draft`;

export const recapEditPath = (recap: Pick<RecapListEntry, 'public_id' | 'slug'>) => `${recapPath(recap)}/edit`;

export const publicIdOf = (recapRef: string) => recapRef.split('-')[0];

// What a recap's own public link opens, outside a workspace (plan task 54).
export const toSharedRecapLink = (token: string) => `${window.location.origin}/r/${token}`;
